import './apiVersion.interceptor';

const apiVersions: Record<string, string> = {};
type ServiceKey = 'core' | 'workflows' | 'companies';

const apiVersionService = {
  getApiVersion(serviceKey: ServiceKey) {
    return apiVersions[serviceKey];
  },
  setApiVersion(serviceKey: ServiceKey, value: string) {
    apiVersions[serviceKey] = value;
  },
};

export default apiVersionService;
